<script>
import Layout from "../layouts/main";
import PageHeader from "../components/page-header";
import axios from "axios";
import { VueLoading } from "vue-loading-template";
import {
  ValidationObserver,
  ValidationProvider,
  localize,
  extend,
} from "vee-validate";

// ルール設定
import * as rules from "vee-validate/dist/rules";
for (let rule in rules) {
  extend(rule, rules[rule]);
}

// 日本語化
import ja from "vee-validate/dist/locale/ja";
localize("ja", ja);

export default {
  components: {
    Layout,
    PageHeader,
    VueLoading,
    ValidationObserver,
    ValidationProvider,
  },
  data() {
    return {
      tableData: [],
      filterItems: [], // フィルタリング用データ
      title: "メール",
      items: [
        {
          text: "Mail",
          href: "/",
        },
        {
          text: "メール",
          active: true,
        },
      ],
      user_id: null,
      currentPage: 1,
      perPage: 5,
      pageOptions: [5, 10],
      filter: null,
      filterOn: ["school_code", "school_name", "user_name", "email"], // フィルタ対象のフィールド
      fields: [
        { key: "school_code", label: "学校コード", sortable: true, tdClass: "minWidth100" },
        { key: "school_name", label: "学校名", sortable: true, tdClass: "minWidth100" },
        { key: "user_name", label: "氏名", sortable: true, tdClass: "minWidth150" },
        { key: "email", label: "メールアドレス", sortable: true, tdClass: "minWidth200" },
        { key: "send_flag", label: "送信有無", sortable: false, tdClass: "minWidth100" },
      ],
      loading: false,
      selectAll: false,
      mail_title: "",
      mail_detail: "",
      selectedSchool: null,
      schoolList: [],
      sendFlagList: [],
      selectedRecipients: [],
      templateList: [], // テンプレート一覧
      templateFields: [
        { key: "name", label: "テンプレート名", sortable: true, tdClass: "minWidth100" },
        { key: "title", label: "タイトル", sortable: true, tdClass: "minWidth100" },
        { key: "detail", label: "詳細", sortable: true, tdClass: "minWidth200" },
        { key: "actions", label: "", sortable: false, tdClass: "minWidth200" },
      ],
      templateCurrentPage: 1, // テンプレートモーダル専用の現在のページ
      templatePerPage: 5, // テンプレートモーダル専用の1ページあたりの件数
      newTemplate: {
        name: "",
        title: "",
        detail: "",
      }, // 新しいテンプレートのデータ
      templateToDelete: null, // 削除対象のテンプレート
      selectedSendFlag: null, // send_flagの検索条件 (null: 全て, true: ON, false: OFF)
      sendFlagOptions: [
        { value: 0, text: "" },
        { value: 1, text: "ON" },
        { value: 2, text: "OFF" },
      ],
      errorList: [], // 送信エラーリスト
      showErrorModal: false, // エラーモーダル表示フラグ
    };
  },
  mounted() {
    this.fetchMailList();
  },
  computed: {
    rows() {
      return this.filterItems.length; // フィルタリング後の件数を返す
    },
    recipientOptions() {
      return this.sendFlagList
        .map((item) => ({
          value: item.user_id,
          text: `${item.school_name} 高校　${item.user_name} 様 <${item.email}>`,
        }));
    },
  },
  watch: {
    selectAll: function (newValue, oldValue) {
      const ids = this.filterItems
        .filter(item => item.send_flag != newValue)
        .map(item => item.user_id);
      if (ids.length > 0) {
        this.updateFlag(ids);
      }
    },
  },
  methods: {
    // メールリストを取得
    fetchMailList() {
      axios
        .get("/api/mail", {
          params: {
            school_code: this.selectedSchool,
            send_flag: this.selectedSendFlag, // send_flagの検索条件を追加
          },
        })
        .then((response) => {
          this.tableData = response.data.mailList.map((item) => {
            return {
              user_id: item.user_id,
              school_code: item.school_code,
              school_name: item.school_name ?? "",
              user_name: item.user_name,
              email: item.email,
              send_flag: item.send_flag,
            };
          });
          this.filterItems = this.tableData;
          this.sendFlagList = response.data.sendFlagList.map((item) => {
            return {
              user_id: item.user_id,
              school_code: item.school_code,
              school_name: item.school_name ?? "",
              user_name: item.user_name,
              email: item.email,
            };
          });
          this.schoolList = [
            { value: null, text: "" },
            ...response.data.schoolList.map((item) => {
              return {
                value: item.school_code,
                text: item.school_code + " : " + item.school_name,
              };
            }),
          ];
        })
        .catch((error) => {
          this.errorProcess(error);
        });
    },
    // フラグ更新
    updateFlag(ids) {
      // idsはユーザーIDの配列
      let formData = new FormData();
      // 配列の場合はすべてappend
      if (Array.isArray(ids)) {
        ids.forEach(id => formData.append("ids[]", id));
      } else {
        formData.append("ids[]", ids);
      }
      let config = {
        headers: {
          "content-type": "multipart/form-data",
        },
      };
      axios
        .post("/api/mail/update/flag", formData, config)
        .then((res) => {
          this.fetchMailList();
        })
        .catch((error) => {
          this.errorProcess(error);
        });
    },
    // // 確定
    // submit() {
    //   let formData = new FormData();
    //   formData.append("user_id", this.user_id);
    //   let config = {
    //     headers: {
    //       "content-type": "multipart/form-data",
    //     },
    //   };
    //   axios
    //     .post("/api/mail/update", formData, config)
    //     .then((res) => {
    //       console.log(formData);
    //       this.fetchMailList();
    //     })
    //     .catch((error) => {
    //       this.errorProcess(error);
    //     });
    // },
    onFiltered(items) {
      console.log(items);
      this.filterItems = items;
    },
    sendMail() {
      if (this.recipientOptions.length === 0) {
        this.$toasted.error("送信先を選択してください");
        return;
      }

      this.loading = true;
      let formData = new FormData();
      formData.append("title", this.mail_title);
      formData.append("detail", this.mail_detail);
      let config = {
        headers: {
          "content-type": "multipart/form-data",
        },
      };
      axios
        .post("/api/mail/send", formData, config)
        .then((res) => {
          this.$toasted.success("メールを送信しました");
          // エラーリストがあればモーダル表示
          if (res.data.errorList && res.data.errorList.length > 0) {
            this.errorList = res.data.errorList;
            this.showErrorModal = true;
          } else {
            this.errorList = [];
            this.showErrorModal = false;
          }
        })
        .catch((error) => {
          this.errorProcess(error);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    showRecipientModal() {
      this.$bvModal.show("recipient-modal");
    },
    hideRecipientModal() {
      this.$bvModal.hide("recipient-modal");
    },
    showTemplateModal() {
      // テンプレートデータを取得
      axios
        .get("/api/mail_templates")
        .then((response) => {
          this.templateList = response.data; // テンプレートデータを格納
          this.$bvModal.show("template-modal"); // モーダルを表示
        })
        .catch((error) => {
          this.errorProcess(error);
        });
    },
    hideTemplateModal() {
      this.$bvModal.hide("template-modal");
    },
    showAddTemplateModal() {
      this.newTemplate = { name: "", title: "", detail: "" }; // 初期化
      this.$bvModal.show("add-template-modal");
    },
    hideAddTemplateModal() {
      this.$bvModal.hide("add-template-modal");
    },
    selectTemplate(template) {
      this.mail_title = template.title; // テンプレートのタイトルを設定
      this.mail_detail = template.detail; // テンプレートの詳細を設定
      this.hideTemplateModal(); // モーダルを閉じる
    },
    addTemplate() {
      axios
        .post("/api/mail_templates/update", this.newTemplate)
        .then(() => {
          this.$toasted.success("テンプレートが追加されました");
          this.hideAddTemplateModal();
          this.fetchTemplates(); // テンプレート一覧を再取得
        })
        .catch((error) => {
          this.errorProcess(error);
        });
    },
    fetchTemplates() {
      axios
        .get("/api/mail_templates")
        .then((response) => {
          this.templateList = response.data;
        })
        .catch((error) => {
          this.errorProcess(error);
        });
    },
    confirmDeleteTemplate(template) {
      this.templateToDelete = template; // 削除対象を設定
      this.$bvModal.show("modal-delete"); // 確認モーダルを表示
    },
    deleteTemplate() {
      if (!this.templateToDelete) return;
      axios
        .post("/api/mail_templates/delete", { ids: [this.templateToDelete.id] }) // idを配列として送信
        .then(() => {
          this.fetchTemplates(); // テンプレート一覧を再取得
          this.templateToDelete = null; // 削除対象をクリア
        })
        .catch((error) => {
          this.errorProcess(error);
          this.templateToDelete = null; // 削除対象をクリア
        });
    },
  },
};
</script>
<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <!-- メール送信 -->
    <div class="row">
      <div class="col-lg-8">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title mb-4">メール送信</h4>
            <ValidationObserver ref="obs" v-slot="ObserverProps">
              <b-form>
                <div class="row">
                  <div class="col-lg-12">
                    <!-- 送信先一覧 -->
                    <b-form-group label="送信先一覧" label-cols-sm="3">
                      <div class="d-flex align-items-end">
                        <b-form-select v-model="selectedRecipients" :options="recipientOptions"
                          class="form-select mb-2 flex-grow-1" disabled multiple></b-form-select>
                        <!-- 送信先選択ボタン -->
                        <b-button variant="primary" @click="showRecipientModal" class="send-select-button ms-2 mb-2">
                          送信先選択
                        </b-button>
                      </div>
                    </b-form-group>
                    <!-- メールタイトル -->
                    <b-form-group label="タイトル" label-cols-sm="3">
                      <ValidationProvider name="タイトル" :rules="{ required: true }">
                        <div slot-scope="ProviderProps">
                          <b-form-input type="text" v-model="mail_title" autocomplete="off"></b-form-input>
                          <p class="text-danger mb-2">
                            {{ ProviderProps.errors[0] }}
                          </p>
                        </div>
                      </ValidationProvider>
                    </b-form-group>
                    <!-- メール詳細 -->
                    <b-form-group label="詳細" label-cols-sm="3">
                      <ValidationProvider name="詳細" :rules="{ required: true }">
                        <div slot-scope="ProviderProps">
                          <b-form-textarea v-model="mail_detail" rows="10" style="width: 100%;"></b-form-textarea>
                          <p class="text-danger mb-2">
                            {{ ProviderProps.errors[0] }}
                          </p>
                        </div>
                      </ValidationProvider>
                    </b-form-group>
                  </div>
                </div>
                <div class="row mt-2">
                  <div>
                    <b-button class="me-2" variant="primary" @click="showTemplateModal">
                      テンプレート選択
                    </b-button>
                    <b-button class="me-2" variant="primary" :disabled="ObserverProps.invalid" @click="sendMail">
                      送信
                    </b-button>
                  </div>
                </div>
              </b-form>
            </ValidationObserver>
          </div>
        </div>
      </div>
    </div>
    <!-- 送信先一覧モーダル -->
    <b-modal id="recipient-modal" title="送信先選択" size="xl" hide-footer>
      <div class="row mb-2 me-2">
        <div class="col-sm-12 col-md-3">
          <b-form-group label-cols-sm="3" label-cols-lg="3" label="学校" label-for="roles" class="mb-2 ms-1 text-start">
            <b-form-select v-model="selectedSchool" :options="schoolList" size="sm"
              class="form-select form-select-sm ms-3" style="width: 150px" @change="fetchMailList"></b-form-select>
          </b-form-group>
        </div>
        <div class="col-sm-12 col-md-3">
          <b-form-group label-cols-sm="3" label-cols-lg="3" label="送信有無" label-for="send-flag"
            class="mb-2 ms-1 text-start">
            <b-form-select v-model="selectedSendFlag" :options="sendFlagOptions" size="sm"
              class="form-select form-select-sm ms-3" style="width: 150px" @change="fetchMailList"></b-form-select>
          </b-form-group>
        </div>
      </div>
      <div class="row">
        <label class="ms-1 mb-0 pb-0">件数：{{ rows }}</label>
      </div>
      <hr class="mt-1 pt-0" />
      <div class="row mt-3">
        <div class="col-sm-12 col-md-6">
          <div id="tickets-table_length" class="dataTables_length">
            <label class="d-inline-flex align-items-center" style="white-space: nowrap">
              表示&nbsp;
              <b-form-select v-model="perPage" size="sm" class="form-select form-select-sm"
                :options="pageOptions"></b-form-select>&nbsp;行
            </label>
          </div>
        </div>
        <div class="col-sm-12 col-md-6">
          <div class="text-md-end">
            <label class="d-inline-flex align-items-center" style="white-space: nowrap">
              フィルタ:
              <b-form-input v-model="filter" type="search" placeholder="Search..."
                class="form-control ms-2"></b-form-input>
            </label>
          </div>
        </div>
      </div>
      <div class="table-responsive">
        <b-table striped hover :items="tableData" :fields="fields" responsive="sm" :per-page="perPage"
          :current-page="currentPage" :filter="filter" :filter-included-fields="filterOn" @filtered="onFiltered">
          <template v-slot:cell(send_flag)="{ item }">
            <b-form-checkbox plain v-model="item.send_flag" @change="updateFlag([item.user_id])">
            </b-form-checkbox>
          </template>
          <template v-slot:head(send_flag)="{ item }">
            <div class="d-flex align-items-center">
              <b-form-checkbox plain v-model="selectAll" class="me-1 d-inline-block">
              </b-form-checkbox>
              <span class="d-inline-block">送信有無</span>
            </div>
          </template>
        </b-table>
      </div>
      <div class="row mb-3">
        <div class="col">
          <div class="dataTables_paginate paging_simple_numbers float-end">
            <ul class="pagination pagination-rounded mb-0">
              <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage"></b-pagination>
            </ul>
          </div>
        </div>
      </div>
      <div class="row mt-2">
        <div class="col-sm-12 col-md-12 mb-3">
          <div id="tickets-table_filter" class="text-md-end">
            <b-button variant="primary" @click="hideRecipientModal">閉じる</b-button>
          </div>
        </div>
      </div>
    </b-modal>
    <!-- テンプレート一覧モーダル -->
    <b-modal id="template-modal" title="テンプレート選択" size="xl" hide-footer>
      <div class="row mt-3">
        <div class="col-sm-12 col-md-6"></div>
        <div class="col-sm-12 col-md-6">
          <div class="text-md-end">
            <label class="d-inline-flex align-items-center" style="white-space: nowrap">
              フィルタ:
              <b-form-input v-model="filter" type="search" placeholder="Search..."
                class="form-control ms-2"></b-form-input>
            </label>
          </div>
        </div>
      </div>
      <div class="table-responsive">
        <b-table striped hover :items="templateList" :fields="templateFields" responsive="sm"
          :per-page="templatePerPage" :current-page="templateCurrentPage" :filter="filter" @filtered="onFiltered">
          <template v-slot:cell(actions)="data">
            <b-button variant="outline-primary" size="sm" class="me-2" @click="selectTemplate(data.item)">
              選択
            </b-button>
            <b-button variant="outline-danger" size="sm" @click="confirmDeleteTemplate(data.item)">
              削除
            </b-button>
          </template>
        </b-table>
      </div>
      <div class="row mb-3">
        <div class="col">
          <div class="dataTables_paginate paging_simple_numbers float-end">
            <ul class="pagination pagination-rounded mb-0">
              <b-pagination v-model="templateCurrentPage" :total-rows="templateList.length" :per-page="templatePerPage">
              </b-pagination>
            </ul>
          </div>
        </div>
      </div>
      <div class="row mt-2">
        <div class="col-sm-12 col-md-12 mb-3">
          <div class="text-md-end">
            <b-button class="me-2" variant="primary" @click="showAddTemplateModal">追加</b-button>
            <b-button variant="primary" @click="hideTemplateModal">閉じる</b-button>
          </div>
        </div>
      </div>
    </b-modal>
    <!-- テンプレート追加モーダル -->
    <b-modal id="add-template-modal" title="テンプレート追加" size="lg" hide-footer>
      <ValidationObserver ref="obs" v-slot="ObserverProps">
        <b-form>
          <div class="row">
            <div class="col-lg-12">
              <!-- テンプレート名 -->
              <b-form-group label="テンプレート名" label-cols-sm="3">
                <ValidationProvider name="テンプレート名" :rules="{ required: true }">
                  <div slot-scope="ProviderProps">
                    <b-form-input type="text" v-model="newTemplate.name" autocomplete="off"></b-form-input>
                    <p class="text-danger mb-2">
                      {{ ProviderProps.errors[0] }}
                    </p>
                  </div>
                </ValidationProvider>
              </b-form-group>
              <!-- メールタイトル -->
              <b-form-group label="タイトル" label-cols-sm="3">
                <ValidationProvider name="タイトル" :rules="{ required: true }">
                  <div slot-scope="ProviderProps">
                    <b-form-input type="text" v-model="newTemplate.title" autocomplete="off"></b-form-input>
                    <p class="text-danger mb-2">
                      {{ ProviderProps.errors[0] }}
                    </p>
                  </div>
                </ValidationProvider>
              </b-form-group>
              <!-- メール詳細 -->
              <b-form-group label="詳細" label-cols-sm="3">
                <ValidationProvider name="詳細" :rules="{ required: true }">
                  <div slot-scope="ProviderProps">
                    <b-form-textarea v-model="newTemplate.detail" rows="10" style="width: 100%;"></b-form-textarea>
                    <p class="text-danger mb-2">
                      {{ ProviderProps.errors[0] }}
                    </p>
                  </div>
                </ValidationProvider>
              </b-form-group>
            </div>
          </div>
          <div class="row mt-2">
            <div class="col-sm-12 col-md-12 mb-3">
              <div class="text-md-end">
                <b-button class="me-2" variant="primary" :disabled="ObserverProps.invalid"
                  @click="addTemplate">確定</b-button>
                <b-button variant="primary" @click="hideAddTemplateModal">閉じる</b-button>
              </div>
            </div>
          </div>
        </b-form>
      </ValidationObserver>
    </b-modal>
    <!-- 削除 -->
    <b-modal id="modal-delete" title="確認" title-class="font-18" @ok="deleteTemplate">
      <p>選択されたデータを削除してよろしいですか？</p>
    </b-modal>
    <!-- エラー一覧モーダル -->
    <b-modal id="error-list-modal" title="送信エラー一覧" size="lg" hide-footer v-if="showErrorModal">
      <div class="row mt-3">
        <div class="col-sm-12 col-md-12">
          <div class="table-responsive">
            <b-table striped hover :items="errorList" :fields="fields" responsive="sm">
              <template v-slot:cell(send_flag)="{ item }">
                <b-form-checkbox plain v-model="item.send_flag" @change="updateFlag([item.user_id])">
                </b-form-checkbox>
              </template>
              <template v-slot:head(send_flag)="{ item }">
                <div class="d-flex align-items-center">
                  <b-form-checkbox plain v-model="selectAll" class="me-1 d-inline-block">
                  </b-form-checkbox>
                  <span class="d-inline-block">送信有無</span>
                </div>
              </template>
            </b-table>
          </div>
        </div>
      </div>
      <div class="row mt-2">
        <div class="col-sm-12 col-md-12 mb-3">
          <div class="text-md-end">
            <b-button variant="primary" @click="showErrorModal = false">閉じる</b-button>
          </div>
        </div>
      </div>
    </b-modal>
    <!-- 送信エラー結果モーダル -->
    <b-modal id="mail-error-modal" v-model="showErrorModal" title="送信エラー一覧" hide-footer>
      <div v-if="errorList.length > 0">
        <p>以下の宛先への送信に失敗しました。</p>
        <b-table :items="errorList" :fields="[
          { key: 'email', label: 'メールアドレス' },
          { key: 'message', label: 'エラー内容' }
        ]" small></b-table>
      </div>
      <div v-else>
        <p>エラーはありません。</p>
      </div>
      <div class="text-end mt-3">
        <b-button variant="primary" @click="showErrorModal = false">閉じる</b-button>
      </div>
    </b-modal>
    <div v-if="loading" class="modal-mask">
      <vue-loading type="spiningDubbles" color="#eee" :size="{ width: '50px', height: '50px' }"></vue-loading>
    </div>
  </Layout>
</template>
<style>
.flex {
  display: flex;
}

.box {
  width: 60px;
  flex-shrink: 0;
}

.minWidth100 {
  min-width: 100px;
  word-break: break-all;
}

.minWidth200 {
  min-width: 200px;
  word-break: break-all;
}

.minWidth300 {
  min-width: 300px;
  word-break: break-all;
}

.right {
  text-align: right;
}

.colorRed {
  color: red;
}

.table-hover tbody tr .colorRed {
  color: red;
}

.table-hover tbody tr:hover .colorRed {
  color: red;
}

.modal-mask {
  z-index: 10;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
}

/* ボタンのスタイルを調整 */
.send-select-button {
  display: block;
  /* ボタンをブロック要素にして下に配置 */
  width: 120px;
  /* ボタンの幅を100pxに設定 */
}
</style>